import { StarTwoTone } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Alert,
  Backdrop,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import loan from "../../images/loanDetails.png";
import receipt from "../../images/mandateAmount.png";
import nachAmount from "../../images/nachAmount.png";
import validity from "../../images/validity.png";
import { CovReducerAction } from "../Store/Cov/CovReducer";
import "./../Pagelayout/PageLayout.css";
import CovDetailScreenContainer from "./CovDetailScreenContainer";
import CovLoanDetailsScreenSelection from "./CovLoanDetailsScreenSelection";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const CovLoanDetailsDashboard = () => {
  const userNames = useSelector((state) => state.branch.userName);
  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);
  const appNum = localStorage.getItem("appNum");

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  //active Branch Name
  const activeBranch = useSelector((state) => state.branch.header.branchName);
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const dispatch = useDispatch();
  //shortcut key
  const backRef = useRef(null);
  const selectRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "covLoanDetail",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "z") {
        backRef.current.click();
      } else if (charCode === "g") {
        selectRef.current.click();
      }
    }
  };

  const filterScreen = useSelector((state) => state.cov.filterScreen);

  // const fieldSelection = useSelector((state) => state.cov.fieldSelection);

  const userName = useSelector((state) => state.branch.userName);

  const screenSelection = useSelector((state) => state.cov.screenSelection);

  const screenSelectionSaveModel = useSelector(
    (state) => state.cov.screenSelectionSaveModel
  );

  const [loading, setLoading] = useState(true);

  const [showDetail, setShowDetail] = useState(false);

  const [screenName, setScreenName] = useState("");

  const [dashboardData, setDashboardData] = useState({});

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
    },
  }));
  const navigate = useNavigate();

  useEffect(() => {
    LoadScreenSelectionData();
    LoadDashboardData();
  }, []);

  const LoadDashboardData = async () => {
    setLoading(true);
    try {
      const response = await axios.post("/customerOneView/getAllLoanDetail", {
        applicationNum: appNum,
      });
      if (response.status === 200) {
        const responseValue = response.data;
        setDashboardData(responseValue);
        if (response.data.loanStatus === "Sanctioned") {
          var selectedFields = [
            "Loan Information",
            "Fee & Other Charges",
            "NACH Details",
          ];
          dispatch(CovReducerAction.updateScreenSelectionRight(selectedFields));
        }

        if (screenSelection.right.length !== 0) {
          setMessage("Loan Details Dashboard Loaded Successfully.");
          setAlertType("success");
          openAlertHandler();
          setTimeout(() => {
            closeAlertHandler();
          }, 3000);
        }
        const branchCodeForSelectedAppNum = responseValue.branchCode;
        // here we get the gl account data based on branch so load this API only after the loan details response only.
        await getGlAccountBasedOnBranchCode(branchCodeForSelectedAppNum);
      }
    } catch {
      setMessage("Error Occured on Loading Dashboard Data.");
      setAlertType("error");
      openAlertHandler();
      setTimeout(() => {
        closeAlertHandler();
      }, 3000);
    }
  };

  const LoadScreenSelectionData = async () => {
    try {
      const response = await axios.post(
        "/customerOneView/getFilterFieldsData",
        {
          userName: userName,
          selectionType: "Screen",
        }
      );
      if (response.status === 200) {
        let record = response.data;
        let screenSelectionValues = {};
        screenSelectionValues.selectionHeaderKey = record.selectionHeaderKey;
        screenSelectionValues.selectionType = record.selectionType;
        screenSelectionValues.userName = record.userName;
        screenSelectionValues.selectionDtl = record.selectionDtl;
        screenSelectionValues.createdBy = record.createdBy;
        screenSelectionValues.lastModifiedBy = record.lastModifiedBy;

        dispatch(
          CovReducerAction.updateScreenSelectionSaveModel(screenSelectionValues)
        );
        if (screenSelectionValues.selectionDtl === null) {
          setMessage("No Saved Screen Selection Data.");
          setAlertType("warning");
          openAlertHandler();
          setTimeout(() => {
            closeAlertHandler();
          }, 3000);
        } else {
          let selectedFields = [];
          const newLeft = [...screenSelection.left];

          screenSelectionValues.selectionDtl.map((row) => {
            selectedFields.push(row.selectionName);
            const currentIndex = newLeft.indexOf(row.selectionName);
            if (currentIndex !== -1) {
              newLeft.splice(currentIndex, 1);
            }
          });

          dispatch(CovReducerAction.updateScreenSelectionLeft(newLeft));
          dispatch(CovReducerAction.updateScreenSelectionRight(selectedFields));

          setMessage("Screen Selection Loaded Successfully.");
          setAlertType("success");
          openAlertHandler();
          setTimeout(() => {
            closeAlertHandler();
          }, 3000);
        }
      } else {
        setMessage("Error Occured on Loading Screen Selection List.");
        setAlertType("error");
        openAlertHandler();
        setTimeout(() => {
          closeAlertHandler();
        }, 3000);
      }
    } catch {
      setMessage("Error Occured on Loading Screen Selection List.");
      setAlertType("error");
      openAlertHandler();
      setTimeout(() => {
        closeAlertHandler();
      }, 3000);
    }
  };

  const onSaveScreenSelectionClick = async (event) => {
    setLoading(true);

    let saveModel = [];
    screenSelection.right.map((row) => {
      let dataMap = {};

      dataMap.selectionDtlKey = 0;
      dataMap.selectionHeaderKey = screenSelectionSaveModel.selectionHeaderKey;
      dataMap.selectionName = row;
      dataMap.createdBy = userName;
      dataMap.createdDate = new Date();
      dataMap.lastModifiedBy = userName;
      dataMap.lastModifiedDate = new Date();
      saveModel.push(dataMap);
    });

    let screenSelectionValues = {};
    screenSelectionValues.selectionHeaderKey =
      screenSelectionSaveModel.selectionHeaderKey;
    screenSelectionValues.selectionType = "Screen";
    screenSelectionValues.userName = userName;
    screenSelectionValues.selectionDtl = saveModel;
    screenSelectionValues.createdBy = userName;
    screenSelectionValues.lastModifiedBy = userName;

    try {
      const response = await axios.post(
        "/customerOneView/insertFilterFieldsData",
        screenSelectionValues
      );

      if (response.status === 200) {
        let record = response.data;
        screenSelectionValues.selectionHeaderKey = record.selectionHeaderKey;
        screenSelectionValues.selectionType = record.selectionType;
        screenSelectionValues.userName = record.userName;
        screenSelectionValues.selectionDtl = record.selectionDtl;
        screenSelectionValues.createdBy = record.createdBy;
        screenSelectionValues.lastModifiedBy = record.lastModifiedBy;

        dispatch(
          CovReducerAction.updateScreenSelectionSaveModel(screenSelectionValues)
        );

        let selectedFields = [];
        screenSelectionValues.selectionDtl.map((row) => {
          selectedFields.push(row.selectionName);
        });

        dispatch(CovReducerAction.updateScreenSelectionRight(selectedFields));
        setLoading(false);
        setMessage("Screen Selection Saved Successfully.");
        setAlertType("success");
        openAlertHandler();
        setTimeout(() => {
          closeAlertHandler();
        }, 3000);
      } else {
        setLoading(false);
        setMessage("Error Occured on Screen Selection Save.");
        setAlertType("error");
        openAlertHandler();
        setTimeout(() => {
          closeAlertHandler();
        }, 3000);
      }
    } catch {
      setLoading(false);
      setMessage("Error Occured on Screen Selection Save.");
      setAlertType("error");
      openAlertHandler();
      setTimeout(() => {
        closeAlertHandler();
      }, 3000);
    }
  };

  const getGlAccountBasedOnBranchCode = async (branchCode) => {
    const branchWithCode = GetBranchDetailsWithCode();
    const codes = branchWithCode.map((branches) => branches.code);
    const activeBranchCode = branchWithCode.find(
      (data) => data.code === branchCode
    );
    const response = await axios.post("/filereceipt/getGLAccountDataByBranch", {
      shflApisModel: {
        apiCode: "FILE_GL_ACC_LOV_API",
        createdBy: userNames,
        lastModifiedBy: userNames,
      },
      branchCodes: codes,
    });
    const response1 = await axios.post("/filepayment/getPaymentBank", {
      apiCode: "BANK_CASH_ACCOUNT_API",
      createdBy: userName,
      lastModifiedBy: userName,
      branchCodes: activeBranchCode.code,
    });
    if (response.status === 200 && response1.status === 200) {
      const response2 = await axios.post(
        "/customerOneView/formGlAccountsMap",

        {
          glAccounts: response.data[activeBranchCode.code].ledger_details,
          ledgerAccounts: response1.data.ledger_details,
        }
      );
      if (response2.status === 200) {
        dispatch(
          CovReducerAction.updateGlAccountsMap(response2.data.glAccounts)
        );
        dispatch(
          CovReducerAction.updateLedgerAccountsList(
            response2.data.ledgerAccounts
          )
        );
        setLoading(false);
      }
    }
  };

  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      )}

      {!loading && (
        <Box>
          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "4px",
              display: "flex",
              gap: "8px",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Tooltip title="Back(Ctrl+Z)">
                <IconButton
                  aria-label="Back"
                  color="primary"
                  onClick={() => {
                    navigate("/stlap/home/CovScreenDashboard");
                  }}
                  ref={backRef}
                >
                  <ArrowBackIcon fontSize="large" />
                </IconButton>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title="Screen Selection(Ctrl+G)">
                <IconButton
                  aria-label="Back"
                  color="primary"
                  disabled={dashboardData.loanStatus === "Sanctioned"}
                  onClick={() => {
                    dispatch(CovReducerAction.updateshowScreenSelection(true));
                  }}
                  ref={selectRef}
                >
                  <StarTwoTone fontSize="large" />
                  {/* <ScreenSearchDesktopIcon fontSize="large" /> */}
                </IconButton>
              </Tooltip>
              {/* <Tooltip title="Field Selection">
              <IconButton
                aria-label="Back"
                color="primary"
                onClick={() => {
                  dispatch(CovReducerAction.updateshowFieldSelection(true));
                }}
              >
                <AssignmentTwoTone fontSize="large" />
              </IconButton>
            </Tooltip> */}
            </Box>
          </Box>
          <Box
            sx={{
              justifyContent: "left",
              marginTop: "8px",
              marginBottom: "4px",
              display: "flex",
              gap: "8px",
            }}
          >
            <h4>Selected Application Number is : {appNum}</h4>
          </Box>

          <Box sx={{ marginLeft: "2rem", marginRight: "2rem" }}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              {screenSelection.right.includes("Loan Information") && (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <Card
                    sx={{ background: "#E0F2F7", borderRadius: "12px" }}
                    onClick={() => {
                      setScreenName("Loan Information");
                      setShowDetail(true);
                    }}
                    className="covListCards"
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "18px",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            <img src={loan} />
                          </Box>

                          <Box>
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                              Loan Information
                            </Typography>
                            <Box
                              sx={{
                                padding: "2px",
                                color: "white",
                                background: "#090979",
                                fontWeight: 600,
                                borderRadius: "8px",
                              }}
                            >
                              {dashboardData.loanStatus}
                            </Box>
                          </Box>
                        </Box>
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography>Loan Type</Typography>
                            <Typography>{dashboardData.loanType}</Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography>Rate of Interest (%)</Typography>
                            <Typography>
                              {dashboardData.rateOfInterest}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>Sanctioned Amount (₹)</Typography>
                            <Typography>
                              {parseInt(
                                dashboardData.sanctionAmount
                              ).toLocaleString("en-IN")}
                            </Typography>
                          </Box>
                          <Box>
                            <BorderLinearProgress
                              variant="determinate"
                              value={100}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              )}
              {screenSelection.right.includes("Disbursement Details") && (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <Card
                    sx={{ background: "#E0F2F7", borderRadius: "12px" }}
                    onClick={() => {
                      setScreenName("Disbursement Details");
                      setShowDetail(true);
                    }}
                    className="covListCards"
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "18px",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            <img src={nachAmount} />
                          </Box>

                          <Box>
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                              Disbursement Details
                            </Typography>
                            <Box
                              sx={{
                                padding: "5px",
                                color: "white",
                                background: "#090979",
                                fontWeight: 600,
                                borderRadius: "8px",
                              }}
                            >
                              No. of Disbursements :
                              {dashboardData.noOfDisbursement}
                            </Box>
                          </Box>
                        </Box>
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>Disbursed Amount (₹)</Typography>
                            <Typography>
                              {parseInt(
                                dashboardData.disbursedAmount
                              ).toLocaleString("en-IN")}
                            </Typography>
                          </Box>
                          <Box>
                            <BorderLinearProgress
                              variant="determinate"
                              value={
                                (parseInt(dashboardData.disbursedAmount) /
                                  parseInt(dashboardData.sanctionAmount)) *
                                100
                              }
                            />
                          </Box>
                        </Box>
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>
                              Balance Amount to be Disbursed(₹)
                            </Typography>
                            <Typography>
                              {parseInt(
                                dashboardData.sanctionAmount -
                                  dashboardData.disbursedAmount
                              ).toLocaleString("en-IN")}
                            </Typography>
                          </Box>
                          <Box>
                            <BorderLinearProgress
                              variant="determinate"
                              value={
                                (parseInt(
                                  dashboardData.sanctionAmount -
                                    dashboardData.disbursedAmount
                                ) /
                                  parseInt(dashboardData.sanctionAmount)) *
                                100
                              }
                            />
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              )}

              {screenSelection.right.includes("Fee & Other Charges") &&
                dashboardData.outstandingAmount !== -1 && (
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <Card
                      sx={{ background: "#E0F2F7", borderRadius: "12px" }}
                      onClick={() => {
                        setScreenName("Fee & Other Charges");
                        setShowDetail(true);
                      }}
                      className="covListCards"
                    >
                      {" "}
                      <CardContent>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              gap: "18px",
                              alignItems: "center",
                            }}
                          >
                            <Box>
                              <img src={loan} />
                            </Box>

                            <Box>
                              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                Fee & Other Charges
                              </Typography>
                              <Box
                                sx={{
                                  padding: "3px",
                                  color: "white",
                                  background: "#090979",
                                  fontWeight: 600,
                                  borderRadius: "8px",
                                }}
                              >
                                OutStanding Amount (₹):{" "}
                                {parseInt(
                                  dashboardData.outstandingAmount
                                ).toLocaleString("en-IN")}
                              </Box>
                            </Box>
                          </Box>
                          <Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography>Paid Amount (₹)</Typography>
                              <Typography>
                                {parseInt(
                                  dashboardData.paidAMount
                                ).toLocaleString("en-IN")}
                              </Typography>

                              {/* <Chip
                            label="9876543212"
                            sx={{
                              color: "white",
                              background: "darkgreen",
                              fontWeight: 600,
                            }}
                          /> */}
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography>Due Amount (₹)</Typography>
                              <Typography>
                                {parseInt(
                                  dashboardData.dueAmount
                                ).toLocaleString("en-IN")}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography>Waived Amount (₹)</Typography>
                              <Typography>
                                {parseInt(
                                  dashboardData.waivedAmount
                                ).toLocaleString("en-IN")}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
              {screenSelection.right.includes("NACH Details") &&
                dashboardData.totalNachAmount !== -1 && (
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <Card
                      sx={{ background: "#E0F2F7", borderRadius: "12px" }}
                      onClick={() => {
                        setScreenName("NACH Details");
                        setShowDetail(true);
                      }}
                      className="covListCards"
                    >
                      <CardContent>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              gap: "18px",
                              alignItems: "center",
                            }}
                          >
                            <Box>
                              <img src={validity} />
                            </Box>

                            <Box>
                              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                NACH Details
                              </Typography>
                              <Box
                                sx={{
                                  padding: "3px",
                                  color: "white",
                                  background: "#090979",
                                  fontWeight: 600,
                                  borderRadius: "8px",
                                }}
                              >
                                Total NACH Amount (₹):{" "}
                                {parseInt(
                                  dashboardData.totalNachAmount
                                ).toLocaleString("en-IN")}
                              </Box>
                            </Box>
                          </Box>
                          <Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography>Sponsor Bank</Typography>
                              <Typography>
                                {dashboardData.sponserBank}
                              </Typography>

                              {/* <Chip
                            label="9876543212"
                            sx={{
                              color: "white",
                              background: "darkgreen",
                              fontWeight: 600,
                            }}
                          /> */}
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography>Last Billing Date</Typography>
                              <Typography>
                                {dashboardData.lastBillingDate === null
                                  ? " "
                                  : new Date(
                                      dashboardData.lastBillingDate
                                    ).toLocaleDateString("fr-FR")}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography>Last NACH Date</Typography>
                              <Typography>
                                {dashboardData.lastNachDate === null
                                  ? " "
                                  : new Date(
                                      dashboardData.lastNachDate
                                    ).toLocaleDateString("fr-FR")}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
              {screenSelection.right.includes("Voucher Details") && (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <Card
                    sx={{ background: "#E0F2F7", borderRadius: "12px" }}
                    onClick={() => {
                      setScreenName("Voucher Details");
                      setShowDetail(true);
                    }}
                    className="covListCards"
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "18px",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            <img src={receipt} />
                          </Box>

                          <Box>
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                              Voucher Details
                            </Typography>
                            <Box
                              sx={{
                                padding: "3px",
                                color: "white",
                                background: "#090979",
                                fontWeight: 600,
                                borderRadius: "8px",
                              }}
                            >
                              Total No. of Vouchers:{" "}
                              {dashboardData.totalVoucher}
                            </Box>
                          </Box>
                        </Box>
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography>
                              Total Voucher Amount(Credit) (₹)
                            </Typography>
                            <Typography>
                              {parseInt(
                                dashboardData.totalVoucherAmountCredit
                              ).toLocaleString("en-IN")}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>
                              {" "}
                              Total Voucher Amount(Debit) (₹)
                            </Typography>
                            <Typography>
                              {parseInt(
                                dashboardData.totalVoucherAmountDebit
                              ).toLocaleString("en-IN")}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>Last Voucher Date</Typography>
                            <Typography>
                              {new Date(
                                dashboardData.lastVoucherDate
                              ).toLocaleDateString("fr-FR")}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              )}
              {screenSelection.right.includes("Receipt Details") && (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <Card
                    sx={{ background: "#E0F2F7", borderRadius: "12px" }}
                    onClick={() => {
                      setScreenName("Receipt Details");
                      setShowDetail(true);
                    }}
                    className="covListCards"
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "18px",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            <img src={receipt} />
                          </Box>

                          <Box>
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                              Receipt Details
                            </Typography>
                            <Box
                              sx={{
                                padding: "3px",
                                color: "white",
                                background: "#090979",
                                fontWeight: 600,
                                borderRadius: "8px",
                              }}
                            >
                              Total No. of Receipts:{" "}
                              {dashboardData.totalReceipt}
                            </Box>
                          </Box>
                        </Box>
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography>Last Receipt Date</Typography>
                            <Typography>
                              {dashboardData.lastReceiptDate !== null
                                ? new Date(
                                    dashboardData.lastReceiptDate
                                  ).toLocaleDateString("fr-FR")
                                : "No Receipts Created"}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>Total Receipt Amount (₹)</Typography>
                            <Typography>
                              {parseInt(
                                dashboardData.totalReceiptAmount
                              ).toLocaleString("en-IN")}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>{"     "}</Typography>
                            <Typography>{"     "}</Typography>
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              )}
              {screenSelection.right.includes("Return Details") && (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <Card
                    sx={{ background: "#E0F2F7", borderRadius: "12px" }}
                    onClick={() => {
                      setScreenName("Return Details");
                      setShowDetail(true);
                    }}
                    className="covListCards"
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "18px",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            <img src={loan} />
                          </Box>

                          <Box>
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                              Return Details
                            </Typography>
                            <Box
                              sx={{
                                padding: "3px",
                                color: "white",
                                background: "#090979",
                                fontWeight: 600,
                                borderRadius: "8px",
                              }}
                            >
                              Total No. of Returns: {dashboardData.totalReturn}
                            </Box>
                          </Box>
                        </Box>
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography>Total Return Charges (₹)</Typography>
                            <Typography>
                              {dashboardData.totalReturnCharge}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>Last Returned Date</Typography>
                            <Typography>
                              {dashboardData.lastReturnedDate !== null
                                ? new Date(
                                    dashboardData.lastReturnedDate
                                  ).toLocaleDateString("fr-FR")
                                : "No Returns Created"}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>{"    "}</Typography>
                            <Typography>{"    "}</Typography>
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          </Box>

          <Dialog
            onClose={() => {
              setShowDetail(false);
            }}
            open={showDetail}
            // TransitionComponent={Transition}
            maxWidth={"md"}
            sx={{ marginTop: "60px" }}
            fullScreen
          >
            <DialogContent>
              <CovDetailScreenContainer
                screenName={screenName}
                setShowDetail={setShowDetail}
                dashboardData={dashboardData}
              />
            </DialogContent>
          </Dialog>
        </Box>
      )}
      <Dialog
        onClose={() => {
          dispatch(CovReducerAction.updateshowScreenSelection(false));
        }}
        open={screenSelection.showScreenSelection}
        sx={{ marginTop: "40px", height: "100%", width: "100%" }}
      >
        <DialogTitle>Screen Selection</DialogTitle>
        <DialogContent>
          <CovLoanDetailsScreenSelection
            onSaveScreenSelectionClick={onSaveScreenSelectionClick}
            setLoading={setLoading}
          />
        </DialogContent>
      </Dialog>

      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CovLoanDetailsDashboard;
